import React from "react";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";

export const NumberFormatter = (value = 0, fraction = 0) => {
  const formatted = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: fraction,
    maximumFractionDigits: fraction,
  }).format(value);

  return <span>{formatted}</span>;
};

export function Capitalize(str) {
  var newStr = str?.toLowerCase();
  if (newStr) {
    return newStr.charAt(0).toUpperCase() + newStr.slice(1);
  } else {
    return str;
  }
}

const preprocessData = (data) => {
  const removeKeys = ["__v", "pins", "updatedAt", "otp", "expiredAt", "statusOrder"];

  const columnsOrder = [
    "_id",
    "profileURL",
    "firstName",
    "lastName",
    "gender",
    "dob",
    "education",
    "experience",
    "documentURL",
    "code",
    "phone",
  ];

  return data.map((item) => {
    // Remove unwanted keys
    const newItem = Object.keys(item)
      .filter((key) => !removeKeys.includes(key))
      .reduce((obj, key) => {
        obj[key] = item[key];
        return obj;
      }, {});

    for (const key in newItem) {
      if (typeof newItem[key] === "boolean") {
        newItem[key] = newItem[key] ? "Yes" : "No";
      }
      if (Array.isArray(newItem[key])) {
        // Check if array contains objects
        const isArrayOfObjects = newItem[key].every(
          (el) => el && typeof el === "object" && !Array.isArray(el)
        );

        if (isArrayOfObjects) {
          newItem[key] = newItem[key]
            .map((obj) => obj?.name || obj?.company || obj?.degree || JSON.stringify(obj))
            .join(", ");
        } else {
          newItem[key] = newItem[key].join(", ");
        }
      }

      // Handle plain objects
      if (newItem[key] && typeof newItem[key] === "object" && !Array.isArray(newItem[key])) {
        // If it has a "name" property, use that, otherwise stringify
        newItem[key] =
          newItem[key].name || newItem[key].businessName || JSON.stringify(newItem[key]);
      }
    }

    // 👇 Reorder keys based on columnsOrder
    const orderedItem = {};
    columnsOrder.forEach((col) => {
      if (newItem.hasOwnProperty(col)) {
        orderedItem[col] = newItem[col];
      }
    });

    // Add remaining keys not in columnsOrder (optional)
    Object.keys(newItem).forEach((key) => {
      if (!orderedItem.hasOwnProperty(key)) {
        orderedItem[key] = newItem[key];
      }
    });

    return orderedItem;
  });
};

export const notify = (msg = "Success!") => toast.success(msg);

export const exportToExcel = (data, fileName = "data.xlsx") => {
  const processed = preprocessData(data);
  // 1. Convert JSON to worksheet
  const worksheet = XLSX.utils.json_to_sheet(processed);

  // 2. Create a workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // 3. Write the workbook to a binary buffer
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  // 4. Create a Blob and trigger download
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, fileName);
};

export const statusColors = {
  active: "success",
  pending: "secondary",
  closed: "error",
};

export const jobStatus = {
  active: "Active",
  pending: "Pending",
  closed: "Closed",
};
